import React from 'react';
import { AccountSettingsContext } from '../../context/AccountSettingsContext';
import { Checkbox } from '../../../components/ui';
import { Row } from '../../../components/ui';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

const FEATURES_LABELS = {
  dashboard: 'Dashboard',
  reviews: 'Avaliações',
  users: 'Usuários',
  treinos: 'Rotinas de Treino',
  social: 'Social',
  communication: 'Comunicação',
  checkins: 'Check-ins',
  points: 'Pontos',
  filials: 'Filiais',
  'info-products': 'Info Produtos',
  banners: 'Banners',
  app: 'App',
  mass_actions: 'Ações em Massa',
}

export const AccountResourcesComponent = () => {
  const {account, features} = React.useContext(AccountSettingsContext);
  const {control, formState: {errors}, getValues} = useFormContext();
  const {fields, append, remove} = useFieldArray({
    control,
    name: 'features',
  })
  console.log('errors', errors);
  return(
    <Row>
      <Controller
        control={control}
        name="features"
        render={({field, field: {value}}) => {
          return (
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {features.map((feature) => (
                <Checkbox key={feature}
                  value={feature}
                  label={FEATURES_LABELS[feature]}
                  checked={account?.features?.includes(feature)}
                  onChange={(val) => {
                    if(val.target.checked){
                      append(feature)
                    } else {
                      remove(feature)
                    }
                  }}
                />
              ))}
            </div>
          )
        }}
      />

      <Controller
        control={control}
        name="federationEnabled"
        defaultValue={account?.federationEnabled ?? false}
        render={({field: {value, onChange}}) => (
          <div style={{marginTop: '24px', borderTop: '1px solid #eee', paddingTop: '16px'}}>
            <Checkbox
              value="federationEnabled"
              label="Publicar a área social em redes abertas (Fediverso)"
              checked={value ?? account?.federationEnabled ?? false}
              onChange={(val) => onChange(val.target.checked)}
            />
            <p style={{color: '#777', fontSize: '13px', marginTop: '8px', maxWidth: '620px'}}>
              Cria um perfil público da conta na rede aberta, que pode ser seguido
              a partir do Mastodon e afins. O conteúdo vai para servidores de
              terceiros no mundo inteiro e <strong>não há como garantir a exclusão</strong> depois
              de publicado. Nada do conteúdo já existente é publicado. Desligar
              solicita a exclusão do que já saiu. Cada aluno ainda precisa
              autorizar, individualmente, a publicação dos próprios posts.
            </p>
          </div>
        )}
      />
    </Row>
  )
}